import React from 'react';
import './ContactsWidget.css';
import templates from './templates';

export const ContactsWidget = ({
  initialData = { contacts: [] },
  template = 'List',
  title = 'אנשי קשר והנהלה',
  showTitle = true,
  columns,
  onSave
}) => {
  const TemplateComponent = templates[template] || templates.List;

  return (
    <TemplateComponent
      initialData={initialData}
      title={title}
      showTitle={showTitle}
      columns={columns}
      onSave={onSave}
    />
  );
};